import * as React           from "react";
import {createElement}      from "react";
import {css, cx}            from "emotion";
import {rgba}               from "polished";
import "./nav-account.scss";
import {FontAwesomeIcon}    from "@fortawesome/react-fontawesome";
import {faBuildingUser,
        faCircleUser,
        faChevronDown}       from "@fortawesome/free-solid-svg-icons";
import {AnyAction}          from "@Common/react/any-action";
import {cs}                 from "@Common/react/chain-services";
import {consumeContext}     from "@Common/react/context";
import {COMPANY_LEVEL,
        OFFICE_LEVEL,
        USER_LEVEL}         from "@Xpresso/routes/common/logic/user-level";
import {CompanyUserIcon}    from "@Xpresso/routes/common/company-user-icon";
import {MenuInternalLink}   from "@Xpresso/routes/common/components/internal-link";
import {GuestModal}         from "@Xpresso/routes/common/guest-modal/guest-modal";
import {getAbsLink}         from "@Xpresso/routes/common/get-abs-link";
import {getProfileLabels}   from "@Xpresso/routes/common/get-profile-labels";
import {keyed} from "@Common/react/keyed";
export const navAccount = ({menu, open, navBlock}) => cs(
    consumeContext("themeScheme"),
    consumeContext("userLevels"),
    consumeContext("session"),
    consumeContext("company"),
    consumeContext("routerHistory"),
    ({}, next) => createElement(AnyAction, {
        disabled: !open.value,
        action: () => open.onChange(null),
        next,
    }),
    ["createModal", ({}, next) => GuestModal({
        content: "newAccount",
        next
    })],
    ["loginModal", ({}, next) => GuestModal({
        content: "login",
        next
    })],
    ({userLevels, themeScheme, session, company, createModal, loginModal, routerHistory}) => {
        const linkLabelLogin = `Login`
        const linkLabelCreate = `Sign up`
        if(userLevels?.isGuest) {
            return (
                <div className="account account-4fcn" >
                    <div className="text-guest">
                        <a className={cx("text-guest-login", css`color: ${themeScheme.xpresso.menuTextColor} !important;`)}
                            onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                loginModal.show()
                            }}
                            xd-qa-type="link"
                            xd-qa-name={linkLabelLogin}
                        >
                            {linkLabelLogin}
                        </a>
                        <a className={cx("text-guest-or", css`color: ${themeScheme.xpresso.menuTextColor} !important;`)}>
                            or
                        </a>
                        <a className={cx("text-guest-create", css`color: ${themeScheme.xpresso.menuTextColor} !important;`)}
                            onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                createModal.show()
                            }}
                            xd-qa-type="link"
                            xd-qa-name={linkLabelCreate}
                        >
                            {linkLabelCreate}
                        </a>
                    </div>
                </div>
            )
        }

        const profileLabels = getProfileLabels({company, session, userLevels});

        const profileBackgroundAlpha = 0.98
        return (
            <div
                className={cx("account account-4fcn", {open: open.value})}
                xd-qa-type="dropdown"
                xd-qa-name="profile"
                style={{color: themeScheme.xpresso.menuTextColor}}
                onMouseEnter={(e) => {
                    open.onChange(true);
                    e.stopPropagation();
                }}
                onMouseLeave={(e) => {
                    open.onChange(false);
                    e.stopPropagation();
                }}
                onClick={(e) => {
                    open.onChange(!open.value);
                    e.stopPropagation();
                }}
            >
                {MenuInternalLink({
                    to: menu?.link,
                    className: "toggle-ov1",
                    navBlock,
                    children: <>
                        {profileImage({userLevels, themeScheme, session})}
                        <div className="text-ov1">
                            {open.value && (
                                profileLabels ? (
                                    `${profileLabels.profileName}\n${profileLabels.orgName}`
                                ) : (
                                    "Loading..."
                                )
                            )}
                        </div>
                        <FontAwesomeIcon icon={faChevronDown}/>
                    </>,
                })}
                <div className="dropdown-ov1" >
                    <div
                        className="items-ov1"
                        style={{background: rgba(themeScheme.xpresso.menuBackgroundColor, profileBackgroundAlpha)}}
                    >
                        {subMenuItems({menu, themeScheme, navBlock})}
                    </div>
                </div>
            </div>
        );
    }
);

const subMenuItems = ({menu, themeScheme, navBlock}) => {
    if(!menu) {
        return
    }

    if(!menu.subMenu) {
        return
    }

    return (
        menu.subMenu.map((item, i) => cs(
            keyed(i),
            () => (
                item.type === "internalUrl" ? (
                    MenuInternalLink({
                        to: item.link,
                        children: item.linkLabel,
                        navBlock,
                        ...sharedPropsSubMenu(themeScheme.xpresso.menuTextColor, item.linkLabel),
                    })
                ) : (
                    <a
                        href={getAbsLink(item.link)}
                        onClick={async (e) => {
                            e.preventDefault();
                            if (await navBlock?.block() === true) {
                                return;
                            }
                            window.location.href = getAbsLink(item.link);
                        }}
                        {...sharedPropsSubMenu(themeScheme.xpresso.menuTextColor, item.linkLabel)}
                    >
                        {item.linkLabel}
                    </a>
                )
            ),
        ))
    )
}

const sharedPropsSubMenu = (menuTextColor, linkLabel) => {
    return {
        "className": cx("item-ov1", css`color: ${menuTextColor} !important;`),
        "xd-qa-type": "dropdown_item",
        "xd-qa-name": `profile ${linkLabel}`,
    }
}

const profileImage = ({userLevels, themeScheme, session}) => {
    if(COMPANY_LEVEL === userLevels?.userLevel) {
        return (
            <div className="icon">
                {CompanyUserIcon({fill: themeScheme?.xpresso.menuTextColor})}
            </div>
        )
    }

    if(USER_LEVEL === userLevels?.userLevel) {
        if(session?.data?.agent?.imageGallery?.headshots[0]?.thumbnailUrl) {
            return (
                <img
                    src={session?.data?.agent?.imageGallery?.headshots[0]?.thumbnailUrl}
                    alt={`${session.data?.agentNameFirst} ${session.data?.agentNameLast}`
                }/>
            )
        }
    }

    return (
        <div className="icon">
            <FontAwesomeIcon className="icon1" icon={profileIcon({userLevels})} color={themeScheme?.xpresso.menuTextColor}/>
        </div>
    )
}

const profileIcon = ({userLevels}) => {
    switch(userLevels?.userLevel) {
        case OFFICE_LEVEL:
            return faBuildingUser
        case USER_LEVEL:
        default:
            return faCircleUser
    }
}
